import React from "react";
import classNames from "classnames";
import { FinancialConnection } from "@common/types/financialConnection";
import { IntegrationAccount } from "@common/types/integrationAccount";
import { FinancialAccount } from "@common/types/financialAccount";
import { useFinancialAccountEntitySelection } from "@hooks/useFinancialAccountEntitySelection";
import { AccountCard } from "@components/financialAccount/AccountCard/AccountCard";
import styles from "./AccountConnectionWidget/AccountsConnectionWidget.module.scss";
import { UpdateFinancialAccountEntity } from "./UpdateFinancialAccountEntity";
import { useFinancialAccountsConnectionContext } from "./FinancialAccountsConnectionContext";

interface FinancialAccountConnectionRowProps {
    integrationAccount: IntegrationAccount;
    financialAccount: FinancialAccount;
    connection?: FinancialConnection;
}

export const FinancialAccountConnectionRow: React.FC<
    FinancialAccountConnectionRowProps
> = ({ integrationAccount, financialAccount, connection: connectionProp }) => {
    const connection = connectionProp ?? integrationAccount.connection!;
    const { showBusinessEntitySelection, nonMockBusinessEntities } =
        useFinancialAccountEntitySelection();
    const entitySelection = showBusinessEntitySelection;
    const { showAccountTypeWarning } = useFinancialAccountsConnectionContext();

    const showWarning =
        showAccountTypeWarning && financialAccount.entity === null;

    let content: React.ReactNode;

    if (nonMockBusinessEntities.length === 0) {
        content = <div>No entities to administer</div>;
    } else {
        content = (
            <UpdateFinancialAccountEntity
                account={financialAccount}
                connection={connection}
                isBusiness
                selectedEntity={financialAccount.entity ?? undefined}
                allowMockEntity
            />
        );
    }

    return (
        <tr
            className={classNames({
                [styles.rowWarning]: showWarning,
            })}
            key={integrationAccount.id}
        >
            <td className={styles.account}>
                <AccountCard
                    account={financialAccount}
                    connection={connection}
                    showNumber
                />
            </td>
            <td>
                {showWarning && (
                    <span className="mr-3 text-warning text-nowrap">
                        Select Entity
                    </span>
                )}
            </td>

            {entitySelection && <td className={styles.entity}>{content}</td>}
        </tr>
    );
};
